export default __webpack_public_path__ + "static/4-adjacent-sibling-6075b87a68f7e842c49b82baade6b75e.png";